import React, { useState, useEffect } from 'react';
import { RequestHeaders } from '../../../../common/header-logo/request-header.component';
import InvoiceDetailsView from "../../invoice/invoice-form/invoice-form-view.container";
import { DetailsDashboard } from '../../../../common/details-dashboard/details-dashboard-layout';
import DetailContainer from '../../../../common/Layout/details/DetailsLayout.component';
import { Selected_Index } from '../../../../../constants/external-constants';
import ChargeMappingView from './charge-mapping-view';
import InvoiceUploader from '../invoice-uploader/invoice-uploader.component';
const ChargeMapping = () => {
    const activeTab = getQueryParam('tab') == 'chargeMapping' ? Selected_Index.i_One : Selected_Index.i_Zero;
    const [contentIndex, setContentIndex] = useState(activeTab);

    const selectedIndex = (index) =>{
        setContentIndex(index);
    }

    function getQueryParam(param) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param);
    }

    return (
    <div className="invoice-wrapper-container inventory-report-component" >
        <RequestHeaders headerTitle={"InvoiceUpload"} />  
        <div className="request-table data-table fit-width">
        
        <DetailContainer
            renderTabContent={selectedIndex}
            urlIndex={activeTab}
            listTab={ [
                {
                    "id": Selected_Index.i_Zero,
                    "label": "Invoice Upload",
                    "hidden": false
                },
                {
                    "id": Selected_Index.i_One,
                    "label": "Charge Mapping",
                    "hidden": false,
                    "disable": false
                },
               
            ]}
        >
            {contentIndex == Selected_Index.i_Zero && <InvoiceUploader /> }
            {contentIndex == Selected_Index.i_One &&  <ChargeMappingView />}

        </DetailContainer>
        </div>
    </div>
    );
}



export default ChargeMapping;